var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{class:['spinner-container', { 'overlay': _vm.overlay }],style:(_vm.containerStyles)},[_c('div',{class:['spinner', `spinner--${_vm.variant}`],style:(_vm.spinnerStyles)},[_c('div',{staticClass:"spinner__circle"})]),(_vm.message)?_c('p',{staticClass:"spinner__message"},[_vm._v(_vm._s(_vm.message))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }